module.exports = __webpack_public_path__ + "img/tour-29.ac03de59.png";